import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import isEmpty from 'lodash/isEmpty';

import { t } from '../../../../modules/infra/i18n';
import Modal from '../../../common/Modal';
import Money from '../../../common/money';
import { taxBreakdownArray } from '../shapes';

const MAX_ENTRIES = 10000;

const getColumns = () => [
  {
    Header: t('reports:tax_breakdown_modal.columns.tax_name'),
    accessor: 'taxName',
    className: 'u-text-center',
  },
  {
    Header: t('reports:tax_breakdown_modal.columns.amount'),
    accessor: 'amount',
    className: 'u-text-center',
    // eslint-disable-next-line react/prop-types
    Cell: ({ value }) => <Money automationId="text:taxBreakdownModal:taxAmount">{value}</Money>,
  },
];

const TaxBreakdownModal = ({ breakdown, close }) => {
  return (
    <Modal
      close={close}
      showCloseButton
      title={t('reports:tax_breakdown_modal.title')}
      automationIdPart="taxBreakdownModal"
    >
      {isEmpty(breakdown) ? (
        <div className="c-plain-text u-text-center u-mv">{t('reports:no_data_message')}</div>
      ) : (
        <ReactTable
          data={breakdown}
          showPagination={false}
          defaultPageSize={MAX_ENTRIES}
          minRows={0}
          resizable={false}
          className="ReactTable ReactTable--row-spacing-only c-inventory-table u-mt+"
          columns={getColumns()}
          getTrProps={(state, rowInfo) => {
            if (!rowInfo) return {};
            const { index } = rowInfo;
            return {
              'data-automation-id': `dataRow:taxBreakdownModal:${index}`,
            };
          }}
        />
      )}
    </Modal>
  );
};

TaxBreakdownModal.propTypes = {
  breakdown: taxBreakdownArray.isRequired,
  close: PropTypes.func.isRequired,
};

export default TaxBreakdownModal;
